import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Input,
  Button,
  FormGroup,
  Label,
} from "reactstrap";
import { Link } from "react-router-dom";

//Import Countdown
import Countdown from "react-countdown";

//Import Logo
import logodark from "../../assets/images/logo-dark.png";
import { ActiveBtn } from "./Button";
import { connect } from "react-redux";

class CommingSoon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      issues: "",
      message: "",
    };

    this.renderer.bind(this);
  }

  renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a completed state
      return <span>Provide your email and we will get in touch asap</span>;
    } else {
      // Render a countdown
      return (
        <>
          <div className="coming-box">
            {days} <span>Days</span>
          </div>{" "}
          <div className="coming-box">
            {hours} <span>Hours</span>
          </div>{" "}
          <div className="coming-box">
            {minutes} <span>Minutes</span>
          </div>{" "}
          <div className="coming-box">
            {seconds} <span>Seconds</span>
          </div>
        </>
      );
    }
  };

  componentDidMount() {
    document.body.classList.add("auth-body-bg");
  }

  componentWillUnmount() {
    document.body.classList.remove("auth-body-bg");
  }
  handleSendEmail = () => {
    // Make sure smtp.js is loaded in the page before using Email.send

    window.Email.send({
      Host: "smtp.zoho.com",
      Username: `undisclosed.recipients@indigoquotient.com`,
      Password: `@URIqlPass123`,
      To: "lavanya.s@indigoquotient.com",
      From: this.props?.user?.email,
      Subject: `SmartComm-Issue-faced-by-${this.props?.user?.name}`,
      Body: "Here is the issues explained",
    })
      .then((message) => alert(message))
      .catch((err) => alert("Failed to send email: " + err));
  };

  render() {
    return (
      <React.Fragment>
        <div>
          {/* <div className="home-btn d-none d-sm-block">
          <Link to="/">
            <i className="mdi mdi-home-variant h2 text-white"></i>
          </Link>
        </div> */}
          {/* <div>
          <Container fluid className="p-0">
            <Row className="no-gutters">
              <Col lg={4}>
                <div className="authentication-page-content p-4 d-flex align-items-center min-vh-100">
                  <div className="w-100 py-4">
                    <Row className="justify-content-center">
                      <Col lg={9}>
                        <div>
                          <div className="text-center">
                            <div>
                              <Link to="/" className="logo">
                                <img src={logodark} height="60" alt="logo" />
                              </Link>
                            </div>

                            <h4 className="font-size-18 mt-4">For Further Assistance please reach out to us at contact@smartcommcms.com</h4>
                            <p className="text-muted">We would love to resolve any queries or difficulties you are facing</p>
                          </div>

                          <div className="p-2 mt-5">
                            <div className="counter-number">
                              <Countdown date="2020/12/31" renderer={this.renderer} />
                            </div>
                          </div>

                          <div className="d-flex flex-column justify-content-center align-items-center w-100 input-section mt-1">
                            <Input type="email" className="form-control mb-3" required placeholder="Enter email address..." />

                            <ActiveBtn name={"Request Support"} handleClick={() => {}} />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
              <Col lg={8}>
                <div className="authentication-bg comingsoon-bg">
                  <div className="bg-overlay"></div>
                </div>
              </Col>
            </Row>
          </Container>
        </div> */}

          <Container fluid className="p-0">
            <Row className="no-gutters">
              <div
                className="authentication-bg comingsoon-bg"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100vh",
                }}
              >
                <div className="bg-overlay"></div>
              </div>
              <Col xs={12} className="p-0">
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    height: "100vh",
                    width: "100%",
                  }}
                >
                  <div
                    className="p-4"
                    style={{
                      maxWidth: "700px",
                      maxHeight: "690px",
                      backgroundColor: "#FFFFFF",
                      boxShadow: "0 0 20px rgba(0, 0, 0, 0.1)",
                      borderRadius: "8px",
                    }}
                  >
                    <Row className="justify-content-center">
                      <Col lg={12}>
                        <div className="authentication-page-content p-4 d-flex align-items-center ">
                          <div className="w-100 py-4">
                            <Row className="justify-content-center">
                              <Col lg={9}>
                                <div>
                                  <div className="text-center">
                                    <div>
                                      <Link to="/" className="logo">
                                        <img
                                          src={logodark}
                                          height="60"
                                          alt="logo"
                                        />
                                      </Link>
                                    </div>

                                    <h4 className="font-size-18 mt-4">
                                      For Further Assistance please reach out to
                                      us at contact@smartcommcms.com
                                    </h4>
                                    <p className="text-muted">
                                      We would love to resolve any queries or
                                      difficulties you are facing
                                    </p>
                                  </div>

                                  {/* <div className="p-2 mt-5">
                                    <div className="counter-number">
                                      <Countdown
                                        date="2020/12/31"
                                        // renderer={this.renderer}
                                      />
                                    </div>
                                  </div> */}

                                  {/* <div className="d-flex flex-column justify-content-center align-items-center w-100 input-section mt-1"> */}
                                  <Row>
                                    <Col lg={12}>
                                      <FormGroup>
                                        <Label>Name</Label>
                                        <Input
                                          type="email"
                                          className="form-control mb-3"
                                          required
                                          placeholder="Enter your Name"
                                          value={this.state.name}
                                          onChange={(e) =>
                                            this.setState({
                                              name: e.target.value,
                                            })
                                          }
                                        />
                                      </FormGroup>
                                    </Col>

                                    <Col lg={12}>
                                      <FormGroup>
                                        <Label>Issue Faced</Label>
                                        <textarea
                                          className="form-control"
                                          id="issueFaced"
                                          name="issueFaced"
                                          rows="3"
                                          placeholder="Enter Issue faced by you"
                                          value={this.state.issues}
                                          onChange={(e) =>
                                            this.setState({
                                              issues: e.target.value,
                                            })
                                          }
                                        ></textarea>
                                      </FormGroup>
                                    </Col>
                                    <Col lg={12}>
                                      <FormGroup>
                                        <Label>Message</Label>
                                        <textarea
                                          className="form-control"
                                          id="issueFaced"
                                          name="issueFaced"
                                          rows="3"
                                          placeholder="Enter if you have any message"
                                          value={this.state.message}
                                          onChange={(e) =>
                                            this.setState({
                                              message: e.target.value,
                                            })
                                          }
                                        ></textarea>
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                  <div className="d-flex justify-content-center">
                                    <ActiveBtn
                                      name={"Send Mail"}
                                      handleClick={() => {
                                        console.log(this.state);
                                        this.handleSendEmail();
                                      }}
                                    />
                                  </div>

                                  {/* </div> */}
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => ({
  user: state.Login.user,
});

export default connect(mapStateToProps)(CommingSoon);
